import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

const MODULE_LABELS: Record<string, string> = {
  dispatch: 'Dispatch board',
  bookings: 'Bookings',
  fleet:    'Fleet & vehicles',
  drivers:  'Drivers & staff',
  patients: 'Patients',
  billing:  'Billing & claims',
  users:    'Users & roles',
  settings: 'System settings',
  dms:      'Document management',
};

@Component({
  selector: 'app-no-access',
  standalone: false,
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.scss'],
})
export class NoAccessComponent implements OnInit {
  moduleName = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService,
  ) {}

  ngOnInit(): void {
    const key = this.route.snapshot.queryParamMap.get('module') ?? '';
    this.moduleName = MODULE_LABELS[key] ?? key;
  }

  goBack(): void { this.router.navigate(['/dashboard']); }

  get userName(): string {
    const u = this.auth.currentUser;
    return u ? `${u.firstName} ${u.lastName}`.trim() : '';
  }

  get userRole(): string {
    return this.auth.currentUser?.role ?? '';
  }
}
